import { FC, memo, useMemo } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer, Panel, Table } from 'ui/components'

import { CompanyDocumentsProps } from './CompanyDocumentsProps'
import { columns } from './columns'

import * as SC from './styles'

export const CompanyDocuments: FC<CompanyDocumentsProps> = memo((props) => {
  const {
    applicationClientDocumentsUploading,
    index,
    readonly,
    isLoading,
    onAddFiles,
    onRemoveFile,
    isDocumentDeleting,
    currentCompany
  } = props
  const { companyName, documents, companyUid } = applicationClientDocumentsUploading

  const mappedAM = useMemo(
    () =>
      documents.map((el) => ({
        item: el
      })),
    [documents]
  )

  const fileAddHandler = (document: File[], documentId: number) => {
    onAddFiles(document, documentId, companyUid)
  }

  return (
    <>
      <Layer rounded shadowed>
        <Panel
          title={
            <div>
              <SC.Subtitle>{`Company #${index + 1}`}</SC.Subtitle>
              <h3>{companyName}</h3>
            </div>
          }
        >
          <Table
            dataQa={TableDataQa.ONBOARDING_FORM_COMPANY_DOCUMENTS_LIST}
            noDataMessage={'No Documents Necessary'}
            columns={columns(
              readonly,
              applicationClientDocumentsUploading.companyName,
              isLoading,
              isDocumentDeleting,
              fileAddHandler,
              onRemoveFile
            )}
            dataSource={mappedAM}
            loading={currentCompany === companyUid}
          />
        </Panel>
      </Layer>
      <div style={{ height: '40px' }} />
    </>
  )
})
